module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/invite-confirmation.png?2dfe3aa44b93345152c801daa0774abc";